import api from '../lib/api'

import assign from 'lodash.assign'
import global from '../types/global.types'
import login from '@/utils/login'

const name = 'custom-time'

export default {
  name,
  namespaced: true,
  state () {
    return {
      confirmTime: {},  // 选中的时间
      hours: [], // swiper中的小时
      mins: [], // swiper中的分钟
      selectType: 1, //订制类型
      isBubbleShow: false, // 弹窗
      data: {},
      selectHourIndex: 7,
      selectMinIndex: 0,
      switchType: 0,
      switchTypeFlag: 0
    }
  },
  getters: {},
  mutations: {
    set (state, data) {
      assign(state, data)
    }
  },
  actions: {
    // 初始化小时和分钟选项
    async 'data:get' ({ commit }) {
      let hours = []
      let mins = []
      for (let i = 0; i < 24; i++) {
        hours.push(i < 10 ? '0' + i : i)
      }
      for (let i = 0; i <= 45; i += 15) {
        mins.push(i < 10 ? '0' + i : i)
      }
      commit('set', {hours, mins})
      const { data } = await api.custom.getInfo()
      if (data) {
        if (data.hour === 24) {
          commit('set', { selectHourIndex: 0, selectMinIndex: 0})
        } else {
          let selectMinIndex = data.min > 0 ? mins.indexOf(data.min) : 0
          commit('set', { selectHourIndex: data.hour, selectMinIndex })
        }
      }
      commit('set', { switchType: data.switch, switchTypeFlag: data.switch})
    },
    async checkLogin () {
      const wpsSid = await login.getWpsSid()

      return wpsSid || login.login()
    },
    async init ({ dispatch }) {
      await dispatch('data:get')
      await dispatch('checkLogin')
    },
    async selectTime ({ commit, state , rootState}, time) {
      const { hour, min } = time
      let pushMin = 0
      if (!hour && !min) {
        pushMin = 24 * 60
      } else {
        pushMin = hour * 60 + min
      }
      const { data } = await api.custom.push(pushMin, state.selectType)()
      if (data) {
        commit('set', { confirmTime: time, isBubbleShow: true })
      } else {
        commit(global.ERR, { message: '抱歉，订制失败，请重试！' }, { root: true })
      }
    }

  }
}
